/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const SecureShield = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--secure-shield"
      {...props}
    >
      <path
        d="M12.0416 5.63981L13.0416 6.63981L8.04158 11.6398L5.54158 9.13981L6.54158 8.13981L8.04158 9.63981L12.0416 5.63981Z"
        fill={props?.fill || '#FF0037'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5416 2.63981L14.187 2.77527C12.9022 2.90375 11.6102 2.61433 10.503 1.95L8.87492 0.973145L7.24682 1.95C6.13961 2.61433 4.84763 2.90375 3.56282 2.77527L2.20825 2.63981V8.19854C2.20825 10.5403 3.43691 12.7103 5.44495 13.9152L8.87492 15.9731L12.3049 13.9152C14.3129 12.7103 15.5416 10.5403 15.5416 8.19854V2.63981ZM14.2083 4.11227C12.6748 4.24203 11.1383 3.88608 9.81702 3.09333L8.87492 2.52807L7.93282 3.09333C6.61157 3.88608 5.07504 4.24203 3.54159 4.11227V8.19854C3.54159 10.0719 4.52451 11.808 6.13094 12.7718L8.87492 14.4182L11.6189 12.7718C13.2253 11.808 14.2083 10.0719 14.2083 8.19854V4.11227Z"
        fill={props?.fill || '#FF0037'}
      />
    </svg>
  );
};

SecureShield.displayName = 'SecureShield';

export default SecureShield;
